import React from 'react';
import theme from '../style/theme';

interface IconProps {
  fillColor?: string;
}

const ChatPlusIcon: React.FC<IconProps> = ({
  fillColor = `${theme.colors.g3}`,
}) => {
  return (
    <svg
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 12">
        <path
          id="Subtract"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.08398 9.92578C2.08398 6.25649 5.89366 2.92578 11.084 2.92578C14.3552 2.92578 17.0779 4.24876 18.6442 6.14567L20.482 5.22676C18.513 2.59982 14.9537 0.925781 11.084 0.925781C5.22862 0.925781 0.0839844 4.75852 0.0839844 9.92578C0.0839844 12.783 1.69259 15.2609 4.08398 16.8746V19.2672C4.08398 20.7742 5.82516 21.614 7.00453 20.6759L9.34483 18.8143C9.91182 18.8877 10.4927 18.9258 11.084 18.9258C13.2693 18.9258 15.3555 18.3919 17.1123 17.4541L15.6289 15.9707C14.316 16.573 12.7731 16.9258 11.084 16.9258C10.4453 16.9258 9.82299 16.8738 9.22342 16.7753C8.94476 16.7295 8.65974 16.8036 8.43874 16.9794L6.08398 18.8525V16.3264C6.08398 15.9753 5.89993 15.65 5.59905 15.4692C3.39758 14.1463 2.08398 12.1141 2.08398 9.92578Z"
          fill={fillColor}
        />
        <path
          id="Union"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.7506 7.42578C19.2613 7.42578 18.8646 7.82244 18.8646 8.31175V10.7065H16.4699C15.9806 10.7065 15.584 11.1031 15.584 11.5924C15.584 12.0817 15.9806 12.4784 16.4699 12.4784H18.8646V14.8731C18.8646 15.3625 19.2613 15.7591 19.7506 15.7591C20.2399 15.7591 20.6366 15.3625 20.6366 14.8731V12.4784H23.0314C23.5207 12.4784 23.9173 12.0817 23.9173 11.5924C23.9173 11.1031 23.5207 10.7065 23.0314 10.7065H20.6366V8.31175C20.6366 7.82244 20.2399 7.42578 19.7506 7.42578Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default ChatPlusIcon;
